import {WBIconButton} from '@wandb/ui';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const Button = styled(WBIconButton)`
  padding: 4px !important;
`;
